const STORAGE_KEY_NS = 'yuncha_main';

// * sytem
export const CookieConfig = { expires: 1 };
export const STORAGE_KEY_TOKEN = `${STORAGE_KEY_NS}_token`;
export const STORAGE_KEY_USERINFO = `${STORAGE_KEY_NS}_userinfo`;
export const PATH_LOGIN = '/login';
export const PATH_CREATE_USER = '/create_user';
export const PATH_RHINO_LOGIN = '/rhino-login';
export const PATH_SEVEN_ELEVEN_LOGIN = '/seven-eleven-login';
export const AUTH_ROUTES_CONFIG = 'AUTH_ROUTES_CONFIG';

export const AccountType = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  MCH: 3,
};

// * common
export const PAGE_SIZE = 20;
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATETIME_START_FORMAT = 'YYYY-MM-DD 00:00:00';
export const DATETIME_END_FORMAT = 'YYYY-MM-DD 23:59:59';
export const DAY_FORMAT = 'YYYY-MM-DD';
export const TIME_FORMAT = 'HH:mm:ss';

// * re-export
export * as error from './error';

// theme
export const THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
};

export const passwordExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{10,}/;
